import * as React from 'react';
import { SvgIcon } from '@material-ui/core';
import leads from './leads.svg'
const Leads = props => {
  return (
  <React.Fragment>
    <img width="30" src ={leads}  />
  </React.Fragment>
  );
};
export default Leads;